import { Container, Icon, Typography } from '@design-system';
import './AnswerItem.scss';
import { GrFormCheckmark } from 'react-icons/gr';
import { IoMdClose } from 'react-icons/io';

type AnswerItemProps = {
    answer: string;
    isRight: boolean;
    isSelected: boolean;
    display?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const AnswerItem: React.FC<AnswerItemProps> = ({ answer, isRight, isSelected, display, className, ...props }) => {
    return (
        <Container
            bordered="grey"
            className={`answer-item ${isRight ? 'right' : 'wrong'} ${isSelected ? 'selected' : ''} ${display ? 'display' : ''} ${className ?? ''}`}
            {...props}
        >
            <Typography intrinsic="p" className="answer-item-text">
                {answer}
            </Typography>
            <div className="answer-icon-wrapper">
                {(isSelected || display) && (
                    <>
                        {isRight ? (
                            <Icon icon={<GrFormCheckmark />} size={20} color="green" />
                        ) : (
                            <Icon icon={<IoMdClose />} size={20} color="red" />
                        )}
                    </>
                )}
            </div>
        </Container>
    );
};
